import React from 'react';
import { AuthConsumer } from 'src/app/contexts/authContext';

export const LogoutCallback = () => (
    <AuthConsumer>
        {({ signoutRedirectCallback }) => {
            signoutRedirectCallback();
            return <span></span>;
        }}
    </AuthConsumer>
);
